<template>
  <div class="back">
    <div class="installation-div">
      <h2 class="header">
        How to Save
      </h2>
      <div class="installation-instructions">
        <div class="col">
          <h2 class="header-font">1. Connect</h2>
          <p class="font">Click the button below to add Shopdrop as a Chrome Extention</p>
          <div class="my-2 add-button">
            <v-btn @click="openChromeStore" large color="rgb(20, 200, 200)">Add to Chrome</v-btn>
          </div>
        </div>
        <div class="col-arrow-top">
          <v-icon size="100">mdi-redo</v-icon>
        </div>
        <div class="col-odd">
          <h2 class="header-font">2. Register</h2>
          <p class="font">Create a Shopdrop user <a @click="redirectToRegister">here</a></p>
        </div>
        <div class="col-arrow-bottom">
          <v-icon size="100">mdi-undo</v-icon>
        </div>
        <div class="col">
          <h2 class="header-font">3. Save</h2>
          <p class="font">Browse your favorite websites and start saving products with one easy click</p>
          <v-img src="../../images/add-shopdrop.jpeg" class="img"> </v-img>
        </div>
      </div>
    </div>
    <div class="image-wrapper">
      <HowToSaveVector class="image" />
    </div>
    <!-- <v-img class="image" src="../../images/2.jpg"> </v-img> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HowToSaveVector from "../../images/HowToSaveVector2.svg";
export default {
  name: "HowToSave",

  components: {
    HowToSaveVector,
  },
  data: () => ({}),
  computed: {
    ...mapGetters(["email"]),
  },
  methods: {
    openChromeStore() {
      window.open(
        "https://chrome.google.com/webstore/detail/dropshop/gemeodelaigfdiekcialemndbakgdicl?hl=en&authuser=2",
        "_blank"
      );
    },
    redirectToRegister() {
      if (!this.email) {
        this.$router.push({ name: "signin" });
      }
    },
  },
};
</script>

<style scoped>
.back {
  display: flex;
  width: 100%;
}
.image {
  max-width: 100%;
  max-height: 100%;
}
.image-wrapper {
  display: flex;
  border: 2px solid #000;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.8);
}
.header {
  font-size: 40px;
  font-weight: 500;
  font-family: graphik lcg, proxima-nova, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  line-height: 1.25;
  margin-top: 3%;
  margin-bottom: 7%;
}
.installation-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  background-color: whitesmoke;
  padding: 1%;
}
.installation-title {
  display: flex;
  align-content: center;
  width: 100%;
}
.installation-instructions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.col {
  display: flex;
  flex-direction: column;
  max-width: 350px;
  margin-right: 250px;
}
.col-arrow-top {
  display: flex;
  flex-direction: column;
  max-width: 350px;
  margin-left: 100px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.col-arrow-bottom {
  display: flex;
  flex-direction: column;
  max-width: 350px;
  margin-right: 100px;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.col-odd {
  display: flex;
  flex-direction: column;
  max-width: 350px;
  margin-left: 450px;
  margin-right: 7px;
}
</style>
